module.exports = __webpack_public_path__ + "static/media/home.9e9c9eb5.svg";